'use client';

import { createContext } from 'react';

import type { TabsRootContextInterface } from '../types/tabs-root.types';

interface TabsRootContextValueInterface extends TabsRootContextInterface {
  activeIndex?: number;
  onNavigate?: (index: number) => void;
}

export const TabsRootContext = createContext<TabsRootContextValueInterface>({});

TabsRootContext.displayName = 'Tabs.Root.Context';
